import React, { useState, useEffect } from 'react'
import {
  isInstitutionalLoggedIn,
  accessStorage,
} from '../../../spa/components/institutional/common/institutionalConfig.js'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import DOMPurify from 'dompurify'
import { safeFetch } from '../../../global/data/service.js'

import {
  colorMap,
  getLinkFromRef,
  getLink,
  isLocal,
  isQa,
  isQaWs3,
  isQaWs5,
  isDev,
} from '../../utility'

import { Title, Subtitle } from '../title/title.jsx'

export function Form({ page, component }) {
  const [isValidating, setIsValidating] = useState()
  const [isSuccess, setIsSuccess] = useState()
  const [isFail, setIsFail] = useState(false)

  const [parameters, setParameters] = useState({
    backgroundColor: null,
    form: null,
  })

  const [styles, setStyles] = useState({
    backgroundColor: null,
  })

  const [blurb, setBlurb] = useState({
    id: null,
    document: null,
    title: null,
    subtitle: null,
    html: null,
    link: null,
  })

  const [form, setForm] = useState({
    fullName: null,
    email: null,
    phone: null,
    message: null,
  })

  const hasUserInfo = () =>
    isInstitutionalLoggedIn() && accessStorage.getUserInfo()

  useEffect(() => {
    if (hasUserInfo()) {
      const userInfo = accessStorage.getUserInfo()
      setForm({
        ...form,
        fullName: userInfo?.fullName,
        email: userInfo?.email,
        phone: userInfo?.phone,
      })
    }
  }, [])

  const _parameters = component?.getParameters()

  // console.log('FORM PARAMETERS >>>>', _parameters)

  const _models = component?.getModels() || {}

  // console.log('FORM MODELS >>>>', _models)

  const { document: _documentRef } = _models

  // console.log('FORM DOCUMENTREF >>>>', _documentRef)

  const _document = _documentRef && page.getContent(_documentRef)

  // console.log('FORM DOCUMENT >>>>', _document)

  useEffect(() => {
    setParameters({
      backgroundColor: _parameters.backgroundColor,
      form: _parameters.form,
    })

    setStyles({
      ...colorMap[_parameters.backgroundColor || 'None'],
    })

    const translatedData = {}

    if (_document) {
      const data = _document.getData()

      // console.log('FORM DATA >>>', data)

      translatedData.title = data.title
      translatedData.subtitle = data.subtitle || data.subhead
      translatedData.html =
        data.html && typeof data.html === 'object'
          ? data.html.value
          : data.html || data.content
      translatedData.link = data.linkCompound
    }

    const { title, subtitle, html, link } = translatedData

    setBlurb({
      id: null,
      document: _document,
      title: title,
      subtitle: subtitle,
      html: html,
      link: getLink(getLinkFromRef(link, page), null),
    })
  }, [page, component, _document])

  const onChangeForm = (e, name) => {
    setForm({ ...form, [name]: e.target.value })
  }

  const onClickSubmit = () => {
    if (
      isNameError(true) ||
      isEmailError(true) ||
      isPhoneError(true) ||
      isMessageError(true)
    ) {
      setIsValidating(true)

      return
    } else {
      setIsValidating(false)
    }

    const to = []
    const RMInfo = accessStorage.getRMInfo()
    if (RMInfo) {
      to.push(RMInfo?.email)
    } else if (isLocal() || isDev() || isQa() || isQaWs3() || isQaWs5()) {
      to.push('Srinivas.Thoopukari@qa.ampf.com')
    } else {
      to.push('NAInstitutionalSalesAnalysts@columbiathreadneedle.com')
    }

    const emailPayLoad = {
      type: 'email',
      data: {
        from: form.email,
        to: to,
        subject: 'CTI Institutional Contact Us Form',
        body: `From: ${form.fullName} <br/> Phone: ${form.phone} <br/> Message: ${form.message}`,
      },
    }

    const url = '/api/email'

    const headers = {
      Accept: 'application/json',
      'Content-type': 'application/json',
    }
    if (isInstitutionalLoggedIn()) {
      headers.Trusted = true
    }

    safeFetch(url, {
      method: 'post',
      headers: headers,
      body: JSON.stringify(emailPayLoad),
      credentials: 'include',
    })
      .then((response) => response.json())
      .then(() => {
        setIsSuccess(true)
        setIsFail(false)
      })
      .catch(() => {
        setIsFail(true)
      })
  }

  const isNameError = (v) => {
    return (isValidating || v) && !form.fullName
  }

  const isEmailError = (v) => {
    return (
      (isValidating || v) &&
      (!form.email ||
        form.email.indexOf('@') < 0 ||
        form.email.indexOf('.') < 0)
    )
  }

  const isPhoneError = (v) => {
    const rawPhone =
      form.phone &&
      form.phone
        .replaceAll(' ', '')
        .replaceAll('-', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll('+', '')

    return (
      (isValidating || v) &&
      (!rawPhone || rawPhone.length < 10 || isNaN(rawPhone))
    )
  }

  const isMessageError = (v) => {
    return (isValidating || v) && !form.message
  }

  return (
    <div
      id={blurb.title?.replaceAll(' ', '').replaceAll("'", '')}
      className={`Form2 u-posRelative ${styles.backgroundColor}`}
    >
      <BrManageContentButton content={_document} />
      <div
        className={`u-sizeConstrained ${
          styles.backgroundColor ? 'u-paddingTop12gu u-paddingBottom8gu' : ''
        }`}
      >
        {blurb.title && <Title text={blurb.title} mode={'medium'} />}
        {isSuccess ? (
          <div className="u-flex u-flexCol u-flexAlignItemsCenter u-marginTop5gu u-padding15gu u-bgColorWhite">
            <div>
              <span
                className="Icon--material u-textColorGreen u-textSizeMsrp5"
                aria-hidden="true"
              >
                check_circle
              </span>
            </div>
            <h4 className="u-textColorBrand u-textSizeMsrp3">
              Thank you for submitting your message
            </h4>
            <div className="u-marginTop2gu u-textSizeMsrp1">
              Our team will respond as soon as possible.
            </div>
          </div>
        ) : (
          <>
            {blurb.subtitle && <Subtitle text={blurb.subtitle} mode="medium" />}
            {blurb.html && (
              <div
                className={`Content u-marginTop2gu`}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(page.rewriteLinks(blurb.html)),
                }}
              />
            )}
            {isFail && (
              <div
                className="u-flex u-flexAlignItemsCenter u-bgColorWhite u-border u-borderColorNeutralLight u-marginVert4gu u-padding3gu"
                style={{ borderRadius: 5 }}
              >
                <span className="Icon--material u-marginRight2gu u-textColorAlert u-textSizeMsrp3">
                  error_outline
                </span>
                <div
                  className="u-textSizeMsrm1 u-textColorLight"
                  style={{ paddingTop: 2 }}
                >
                  <span className="u-textBold u-textSecondary">
                    We&apos;re experiencing technical difficulties.
                  </span>{' '}
                  Your message could not be submitted at this time. Please try
                  again later.
                </div>
              </div>
            )}
            {parameters.form === 'Contact Us' && !isSuccess && (
              <div>
                <div className="u-flex u-sm-flexCol">
                  <div className="u-size1of2 u-sm-sizeFull u-paddingRight5gu u-sm-paddingRight0">
                    <div className="u-marginTop3gu">
                      <label htmlFor="cti_form_fullName" className="Form-label">
                        Full name
                      </label>
                      <div className="Input-group">
                        <input
                          id="cti_form_fullName"
                          className={`Input ${
                            isNameError() ? 'Input--error' : ''
                          } u-marginTop1gu`}
                          type="text"
                          name="fullName"
                          defaultValue={form.fullName}
                          onChange={(e) => onChangeForm(e, 'fullName')}
                        />
                        {isNameError() && (
                          <span className="Input-icon Icon">&#xE002;</span>
                        )}
                      </div>
                      <p className="Form-help u-textColorAlert">
                        {isNameError() ? (
                          <>Please enter full name.</>
                        ) : (
                          <>&nbsp;</>
                        )}
                      </p>
                    </div>
                    <div className="u-marginTop3gu">
                      <label htmlFor="cti_form_email" className="Form-label">
                        Email address
                      </label>
                      <div className="Input-group">
                        <input
                          id="cti_form_email"
                          className={`Input ${
                            isEmailError() ? 'Input--error' : ''
                          } u-marginTop1gu`}
                          type="text"
                          name="email"
                          defaultValue={form.email}
                          onChange={(e) => onChangeForm(e, 'email')}
                        />
                        {isEmailError() && (
                          <span className="Input-icon Icon">&#xE002;</span>
                        )}
                      </div>
                      <p className="Form-help u-textColorAlert">
                        {isEmailError() ? (
                          <>Please enter a valid email.</>
                        ) : (
                          <>&nbsp;</>
                        )}
                      </p>
                    </div>
                    <div className="u-marginTop3gu">
                      <label htmlFor="cti_form_phone" className="Form-label">
                        Phone number
                      </label>
                      <div className="Input-group">
                        <input
                          id="cti_form_phone"
                          className={`Input ${
                            isPhoneError() ? 'Input--error' : ''
                          } u-marginTop1gu`}
                          type="text"
                          name="phone"
                          defaultValue={form.phone}
                          onChange={(e) => onChangeForm(e, 'phone')}
                        />
                        {isPhoneError() && (
                          <span className="Input-icon Icon">&#xE002;</span>
                        )}
                      </div>
                      <p className="Form-help u-textColorAlert">
                        {isPhoneError() ? (
                          <>Please enter a valid phone number.</>
                        ) : (
                          <>&nbsp;</>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="u-size1of2 u-sm-sizeFull">
                    <div className="u-marginTop3gu">
                      <label htmlFor="cti_form_message" className="Form-label">
                        Message
                      </label>
                      <div className="Input-group">
                        <textarea
                          id="cti_form_message"
                          className={`Input ${
                            isMessageError() ? 'Input--error' : ''
                          } u-marginTop1gu u-textBreak`}
                          name="message"
                          placeholder=""
                          rows="6"
                          style={{ height: 267 }}
                          onChange={(e) => onChangeForm(e, 'message')}
                        />
                        {isMessageError() && (
                          <span className="Input-icon Icon">&#xE002;</span>
                        )}
                      </div>
                      <p className="Form-help u-textColorAlert">
                        {isMessageError() ? (
                          <>Please enter a message.</>
                        ) : (
                          <>&nbsp;</>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="u-marginTop5gu">
                  <button
                    className="Button Button--primary"
                    onClick={onClickSubmit}
                    data-analytics="contact-us-submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
